// Backend LocalDate fields arrive as plain "YYYY-MM-DD" strings. Parsing those with
// `new Date(str)` reads them as UTC midnight, which can shift the calendar day when
// rendered in a timezone behind UTC — so we pull the parts out directly instead.
export const parseYMD = (str) => {
  if (!str) return null;
  const [year, month, day] = str.split('-').map(Number);
  return { year, month: month - 1, day }; // month is 0-indexed, matching Date
};

export const MONTH_NAMES = [
  'January', 'February', 'March', 'April', 'May', 'June',
  'July', 'August', 'September', 'October', 'November', 'December',
];

// Full years completed between `fromStr` (a LocalDate string) and today.
export const completedYears = (fromStr) => {
  const from = parseYMD(fromStr);
  if (!from) return 0;
  const today = new Date();
  let years = today.getFullYear() - from.year;
  const beforeAnniversary =
    today.getMonth() < from.month ||
    (today.getMonth() === from.month && today.getDate() < from.day);
  if (beforeAnniversary) years -= 1;
  return years;
};

// Does `dateStr` (a LocalDate string) fall on today's month/day, regardless of year?
export const isTodayMonthDay = (dateStr) => {
  const parsed = parseYMD(dateStr);
  if (!parsed) return false;
  const today = new Date();
  return parsed.month === today.getMonth() && parsed.day === today.getDate();
};

// Years completed on `fromStr`'s anniversary within the current calendar year — used for
// month-by-month browsing, where (unlike completedYears()) it shouldn't matter whether
// that date has already passed this year or is still coming up.
export const yearsInCurrentCalendarYear = (fromStr) => {
  const from = parseYMD(fromStr);
  if (!from) return 0;
  return new Date().getFullYear() - from.year;
};
